export default __webpack_public_path__ + "static/media/alarme.b31ff87d.svg";